import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  size = "medium",
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  size?: "small" | "medium" | "large";
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {

  const sizeClass = (size === "small" || small) ? "h-4 w-auto" : size === "large" ? "h-12 w-auto" : "h-5 w-auto";

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9 dark:invert" alt="SOON Connect" title="SOON Connect" src={`${src}?type=icon`} />
        ) : (
          <img
            className={classNames(sizeClass, "dark:invert")}
            alt="SOON Connect"
            title="SOON Connect"
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
